import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm, change, untouch } from "redux-form";
import PropTypes from "prop-types";
import * as configs from "./config";
import ReactTags from "react-tag-autocomplete";
import renderSelectField from "../../../../shared/components/form/Select";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    api: 0,
    type: "Premium",
    subnet_suggestions: [],
    subnets: [],
    noOfProxies: 0,
    proxies: [],
  };

  componentDidMount() {
    if (this.props.edit.id !== undefined) {
      delete this.props.edit.subnets;

      this.props.initialize(this.props.edit);
      this.setState(this.props.edit, () => {
        this.props.handleForm(this.state);
      });
    } else {
      this.props.handleForm(this.state);
      // this.props.initialize({ valid: 30 });
    }

    this.inputRef = React.createRef();
  }

  setValidDays = (event) => {
    this.setState({ valid: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  getLocations = () => {
    let locations = [];
    this.props.subnets.forEach((subnet) => {
      let location = locations.filter(
        (obj) => obj.value === subnet.geo_maxmind
      );

      if (location.length === 0) {
        locations.push({
          value: subnet.geo_maxmind,
          label: subnet.geo_maxmind,
        });
      }
    });
    locations.sort(function(a, b) {
      var x = a["value"];
      var y = b["value"];
      return x < y ? -1 : x > y ? 1 : 0;
    });

    return locations;
  };

  filterSubnets = (event) => {
    let filteredSubnets = this.props.subnets.filter(
      (obj) => event.value === obj.geo_mm_cc
    );

    let subnets = [];
    filteredSubnets.forEach((subnet) => {
      subnets.push({
        slug: subnet.sid,
        name: subnet.subnet,
      });
    });

    this.setState({ subnet_suggestions: subnets, subnets: [] });
  };

  onDelete(i) {
    const subnets = this.state.subnets.slice(0);
    subnets.splice(i, 1);
    this.setState({ subnets }, () => {
      this.props.handleForm(this.state);
    });
  }

  onAddition(subnet) {
    const subnets = [].concat(this.state.subnets, subnet);
    this.setState({ subnets }, () => {
      this.props.handleForm(this.state);
    });
  }

  printInput = (input) => {
    switch (input.key) {
      case "valid":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={configs.validDays}
            onChange={this.setValidDays}
          />
        );
      default:
        return (
          <Field
            name={input.key}
            component="input"
            type={input.type}
            placeholder={input.name}
            onKeyUp={this.formChangeHandler}
          />
        );
    }
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  removeProxy = (proxy) => {
    this.setState(
      {
        proxies: this.state.proxies.filter((obj) => proxy.sid !== obj.sid),
      },
      () => {
        this.props.handleForm(this.state);
      }
    );
  };

  addProxies = () => {
    let proxies = this.state.proxies;

    if (this.state.subnets.length > 0 && this.state.noOfProxies > 0) {
      let subnets = this.state.subnets;

      let mod = parseInt(
        parseInt(this.state.noOfProxies) % this.state.subnets.length
      );

      subnets.map((subnet) => {
        let subnetObj = this.props.subnets.filter(
          (obj) => subnet.name === obj.subnet
        );

        console.log("filteredSubnets", subnetObj, subnet);

        if (subnetObj.length > 0) {
          Object.keys(subnetObj[0]).forEach(function(key) {
            subnet[key] = subnetObj[0][key];
          });
        }

        subnet["no"] =
          parseInt(
            parseInt(this.state.noOfProxies) / this.state.subnets.length
          ) + mod;

        mod = 0;

        return subnet;
      });

      subnets.forEach((subnet) => {
        proxies.push({
          sid: subnet.sid,
          subnet: subnet.subnet,
          lid: subnet.lid,
          no: subnet.no,
          location: subnet.geo_maxmind,
        });
      });

      this.setState({ proxies: proxies, subnets: [], noOfProxies: 0 }, () => {
        this.props.dispatch(change("add_package_form", "location", null));
        this.props.dispatch(untouch("add_package_form", "location"));

        this.props.dispatch(change("add_package_form", "noOfProxies", null));
        this.props.dispatch(untouch("add_package_form", "noOfProxies"));

        this.props.handleForm(this.state);
      });
    } else {
      this.props.showError(["Please select subnet(s) and number of proxies."]);
    }
  };

  render() {
    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={() => {}}
        >
          {configs.columnHeader.map((input, index) =>
            !input.system ? (
              <div className="form__form-group" key={index}>
                <span className="form__form-group-label">{input.name}</span>
                <div className="form__form-group-field">
                  {this.printInput(input)}
                </div>
              </div>
            ) : (
              ""
            )
          )}
          <React.Fragment>
            <div className="form__form-group">
              <div className="form__form-group-label col-sm-3 col-md-3">
                Location
              </div>
              <div className="form__form-group-label col-sm-3 col-md-3">
                Subnets
              </div>
              <div className="form__form-group-field col-sm-3 col-md-3">
                Proxies
              </div>
            </div>
            <div className="form__form-group">
              <div className="col-sm-3 col-md-3">
                <Field
                  name="location"
                  component={renderSelectField}
                  options={this.getLocations()}
                  onChange={this.filterSubnets}
                />
              </div>
              <div className="col-sm-3 col-md-3">
                <ReactTags
                  ref={this.inputRef}
                  tags={this.state.subnets}
                  allowNew={false}
                  suggestions={this.state.subnet_suggestions}
                  onDelete={this.onDelete.bind(this)}
                  onAddition={this.onAddition.bind(this)}
                  placeholderText="Add location"
                  addOnBlur={true}
                  minQueryLength={1}
                />
              </div>
              <div className="col-sm-3 col-md-3">
                <Field
                  name="noOfProxies"
                  component="input"
                  type="number"
                  placeholder="No of proxies"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
              <div className="col-sm-3 col-md-3 successParentDiv">
                <span
                  className="lnr lnr-plus-circle"
                  title="Add"
                  onClick={this.addProxies}
                ></span>
              </div>
            </div>
            {this.state.proxies.map((proxy, index) => (
              <div className="form__form-group" key={index}>
                <div className="col-sm-3 col-md-3">{proxy.location}</div>
                <div className="col-sm-3 col-md-3">{proxy.subnet}</div>
                <div className="col-sm-3 col-md-3">{proxy.no}</div>
                <div className="col-sm-3 col-md-3 trashParentDiv">
                  <span
                    className="lnr lnr-trash"
                    title="Remove"
                    onClick={() => this.removeProxy(proxy)}
                  ></span>
                </div>
              </div>
            ))}
          </React.Fragment>
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "add_package_form", // a unique identifier for this form
})(HorizontalForm);
